export const NFTCONTRACT = "0x84780AD4CeDC09b8A00B0b0e9824fEeBD11179AB";
export const STAKINGCONTRACT = "0x3c8bf11c86372E422Ad1f8767CBB92b3578Be322";
export const polygonscanapi = "https://api.bscscan.com";
export const moralisapi = "https://deep-index.moralis.io/api/v2/";
export const nftpng =
  "https://sct.mypinata.cloud/ipfs/QmXuJwAzKNW7okPU6BTLQnctUbTcZJqLZ8pxdzT8HrRvJn/";
